export default __webpack_public_path__ + "static/media/unnamed.7de8ea5d.png";